import { Component, OnInit, OnDestroy } from '@angular/core';
import { AccessGroupService } from './../../access-group.service';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../../environments/environment';
import { Store } from "@ngrx/store";
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { LambdaFunctionService } from '../../../service/lambda-function.service';

declare var jQuery: any;

@Component({
  selector: 'app-dynamic-learner-map',
  templateUrl: './dynamic-learner-map.component.html',
  styleUrls: ['./dynamic-learner-map.component.scss']
})
export class DynamicLearnerMapComponent implements OnInit, OnDestroy {

  public currentLM_id: string;
  public currentLM: any;
  public allcolumns: any;
  public learner_map: string;
  public child: string = '';
  designView: boolean = false;
  lm_maptype: string = '';
  loading: boolean = false;

  private destroy$ = new Subject<void>();

  constructor(
    private accessgroup: AccessGroupService,
    private sanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private router: Router,
    private lmda_service: LambdaFunctionService,
    public http: HttpClient,
    public store: Store<any>
  ) {}

  ngOnInit() {
    localStorage.setItem('appNoli', 'false');

    // Design View requires both owner role AND learner_maps_admin access
    this.store.select<any>((state) => state.profile?.account).pipe(
      takeUntil(this.destroy$),
      filter(account => !!account)
    ).subscribe(account => {
      const isOwner = account?.primary_role === 'owner';
      if (isOwner) {
        this.checkAdminAccess();
      }
    });

    // Track active card from URL — update on navigation (next/prev/click)
    const updateActiveCard = () => {
      const url = this.router.url;
      const match = url.match(/\/card\/([^/?#]+)/);
      this.child = match ? match[1] : '';
    };
    updateActiveCard();
    this.router.events.pipe(
      takeUntil(this.destroy$),
      filter(e => e instanceof NavigationEnd)
    ).subscribe(() => updateActiveCard());

    this.activatedRoute.params.pipe(
      takeUntil(this.destroy$)
    ).subscribe((params: Params) => {
      if (this.currentLM_id === params['id']) return;

      this.currentLM = '';
      this.loading = true;
      this.currentLM_id = params['id'];

      this.http.get(`${environment.profileURL}/api/v1/learner_maps/${params['id']}`).pipe(
        takeUntil(this.destroy$)
      ).subscribe(
        (lmRes: any) => {
          this.allcolumns = lmRes?.learner_map?.learner_map_columns?.sort((a, b) => a?.order - b.order);
          if (this.allcolumns) {
            this.currentLM = { columns: this.allcolumns };
          }

          this.learner_map = (lmRes?.learner_map?.title || '').replace(/#/g, ' ');
          this.currentLM = lmRes;
          this.loading = false;
        },
        (err) => {
          this.loading = false;
        }
      );
    });
  }

  private checkAdminAccess() {
    this.store.select<any>((state) => state.profile.accessGroupData).pipe(
      takeUntil(this.destroy$)
    ).subscribe((message) => {
      if (message && Object.keys(message).length > 0) {
        this.designView = !!message?.main_menu?.learner_maps_admin;
      }
    });
  }

  public async getLearnerMapColCard(lmId: string) {
    const args = { lm_id: lmId, compName: "admin-single" };
    try {
      if (!this.router.url.includes("profile-slideshow") && args.lm_id !== "presentation") {
        await this.lmda_service.lambda_invoke("read-dynamoDb-data", args);
      }
    } catch (err) {
      console.error(err);
    }
    this.lmda_service.lambda_res.pipe(
      takeUntil(this.destroy$)
    ).subscribe((res) => {
      const allcolumns = res["response"]?.body;
      allcolumns?.sort((a, b) => a?.order?.N - b.order?.N);
      allcolumns?.forEach((col) => {
        col.cards?.sort((a, b) => a?.order?.N - b.order?.N);
      });
      this.allcolumns = allcolumns;
      if (this.currentLM) {
        this.currentLM.columns = allcolumns;
      }
      this.loading = false;
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
